module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page messages-page"
  }, [(_vm.show_stopPopup) ? _c('div', {
    staticClass: "messages-stop-music-section"
  }, [_c('div', {
    staticClass: "popup-section"
  }, [_c('img', {
    staticClass: "popup-image",
    attrs: {
      "src": "/static/images/earphone.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "popup-title"
  }, [_vm._v("Direct Messages")]), _vm._v(" "), _c('p', {
    staticClass: "popup-text"
  }, [_vm._v("\n        Direct messages is where you can share music + product directly, view\n        repost requests & approve collaborations.\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "gotta-btn",
    nativeOn: {
      "click": function($event) {
        _vm.setVisitedTime()
      }
    }
  }, [_vm._v("Ok. Got it!")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('v-container', {
    staticClass: "messages-page-content",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [(!_vm.conversations || _vm.conversations.length == 0) ? _c('v-flex', {
    staticClass: "message-rooms-section empty-section",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("No messages")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("Your conversations will appear here.")])]) : [_c('v-flex', {
    staticClass: "conversations",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "conversations__header"
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "conversations__count"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/conversation.svg"),
      "alt": "conversation",
      "width": "16"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.conversations.length < 99 ? _vm.conversations.length : "99+") + " conversations")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "mode-toggle",
    on: {
      "click": _vm.modeToggle
    }
  }, [_c('div', {
    staticClass: "toggle"
  }, [_c('div', {
    attrs: {
      "id": "dark-mode",
      "type": "checkbox"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "conversations__content"
  }, _vm._l((_vm.conversations), function(conv) {
    return _c('div', {
      key: ("conversation-" + (conv.id)),
      staticClass: "message-room-item",
      class: {
        new: conv.last_message && !conv.last_message.is_read,
        selected: conv.id == _vm.conversation.id,
      },
      on: {
        "click": function($event) {
          _vm.selectedConversation(conv)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (conv.other.slug))
      }
    }, [(!conv.other.length) ? _c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' +
        conv.other.avatar.thumb.url +
        ');')
    }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('div', {
      staticClass: "conversation-info"
    }, [_c('div', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(conv.other.display_name))]), _vm._v(" "), _c('div', {
      staticClass: "messaged-time"
    }, [_vm._v("\n                    " + _vm._s(_vm.datetimePeriodFormat(new Date(conv.last_message.created_at))) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "short-message",
      domProps: {
        "innerHTML": _vm._s(conv.last_message.body.substring(0, 20))
      }
    })])])
  }))]), _vm._v(" "), (_vm.conversation && _vm.conversation.id > 0) ? _c('v-flex', {
    staticClass: "message-content-section",
    attrs: {
      "xs12": "",
      "sm6": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "user-name"
  }), _c('div', {
    staticClass: "user-avatar-image",
    style: ({
      'background-image': 'url(' + _vm.conversation.other.avatar.thumb.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('h2', [_vm._v(_vm._s(_vm.conversation.other.display_name))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(_vm.conversation.other.username) + " ")]), _vm._v(" • "), _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.conversation.other.user_type))])]), _vm._v(" "), _c('p')]), _vm._v(" "), (_vm.messages && _vm.messages.length > 0) ? _c('div', {
    staticClass: "message-list-section"
  }, _vm._l((_vm.messages), function(message) {
    return _c('message', {
      key: message.id,
      attrs: {
        "message": message,
        "is-own": _vm.conversation.other.id != message.sender.id
      },
      on: {
        "updated": _vm.refreshMessages
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "send-message-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.message.body),
      expression: "message.body",
      modifiers: {
        "trim": true
      }
    }],
    ref: "message",
    staticClass: "message-input-box",
    attrs: {
      "type": "text",
      "maxlength": "500",
      "placeholder": "Write a message...",
      "disabled": !(_vm.currentUser.creator_verified),
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.message.body)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.checkMessage()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "body", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.showEmojiPicker) ? _c('picker', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.hideEmojiDialog),
      expression: "hideEmojiDialog"
    }],
    staticClass: "emoji-picker",
    attrs: {
      "title": "Pick your emoji…",
      "emoji": "point_up"
    },
    on: {
      "click": _vm.addEmoji
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "show-emoji-box-btn",
    class: {
      selected: _vm.showEmojiPicker
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEmojiDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("tag_faces")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "flex-column share-message-content",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('div', {
    staticClass: "search-content-title"
  }, [_vm._v("\n              Share content in conversation\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "search content"
  }, [_c('input', {
    staticClass: "search-content",
    attrs: {
      "type": "text",
      "placeholder": "search"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-conversation"
  }, [_c('div', {
    staticClass: "conversation-avatar"
  }, [_c('a', {
    attrs: {
      "href": "/9234ds"
    }
  }, [_c('div', {
    staticClass: "avatar-image",
    staticStyle: {
      "background-image": "url('https://d19mruzykfu6hg.cloudfront.net/uploads/user/avatar/121/thumb_bae70610-6589-40a1-a210-6cec61767a75.png')"
    },
    attrs: {
      "data-v-5be2a303": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "conversation-info"
  }, [_c('div', {
    staticClass: "conversation-info",
    attrs: {
      "data-v-5be2a303": ""
    }
  }, [_c('div', {
    staticClass: "user-name",
    attrs: {
      "data-v-5be2a303": ""
    }
  }, [_vm._v("Bruh Make Beats")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title",
    attrs: {
      "data-v-5be2a303": ""
    }
  }, [_vm._v("ALBUM")])])])])])])])]], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "messages-repost"
    },
    model: {
      value: (_vm.show_repost_modal),
      callback: function($$v) {
        _vm.show_repost_modal = $$v
      },
      expression: "show_repost_modal"
    }
  }, [_c('v-card', {
    staticClass: "pa-5"
  }, [(
    ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('div', {
    staticClass: "requests",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [(_vm.otherStripeConnected) ? [_c('div', {
    staticClass: "requests__header"
  }, [_c('div', {
    staticClass: "requests__actions"
  }, [_c('div', {
    staticClass: "requests__title"
  }, [_vm._v("Repost Request")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [(
    ['artist', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('v-btn', {
    class: {
      'btn--active': _vm.tab == 'album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('album')
      }
    }
  }, [_vm._v("Album")]) : _vm._e(), _vm._v(" "), (
    ['artist', 'brand', 'label'].indexOf(
      _vm.currentUser.user_type
    ) > -1
  ) ? _c('v-btn', {
    class: {
      'btn--active': _vm.tab == 'merch'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('merch')
      }
    }
  }, [_vm._v("Product")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "requests__content"
  }, [(_vm.tab == 'album') ? _vm._l((_vm.albums), function(album) {
    return _c('div', {
      key: album.id,
      staticClass: "request-item",
      class: {
        selected: _vm.item == album,
        banned: _vm.InBanned(album),
      },
      on: {
        "click": function($event) {
          _vm.InBanned(album) ? null : _vm.selectItem(album)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(album.user.username))])])])
  }) : (_vm.tab == 'merch') ? _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "request-item",
      class: {
        selected: _vm.item == product,
        banned: _vm.InReposted(product),
      },
      on: {
        "click": function($event) {
          _vm.InReposted(product) ? null : _vm.selectItem(product)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  }) : _vm._e()], 2)] : [_c('div', {
    staticClass: "requests__body"
  }, [_c('h5', [_vm._v("Repost Request")]), _vm._v(" "), _c('p', [_vm._v("\n              To promote albums and products"), _c('br'), _vm._v("\n              receiver must first connect to Stripe\n            ")])])]], 2) : _vm._e()])], 1), _vm._v(" "), (_vm.show_repost_payment_modal) ? _c('repost-payment-modal', {
    attrs: {
      "item": _vm.item,
      "itemType": _vm.tab,
      "receiver": _vm.conversation.other,
      "dismiss": _vm.closeRepostPaymentModal,
      "finish": _vm.sendMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_send_love_modal) ? _c('send-love-modal', {
    attrs: {
      "item": _vm.conversation.other,
      "dismiss": _vm.closeSendLoveModal
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_block_user_confirm_dialog),
      callback: function($$v) {
        _vm.show_block_user_confirm_dialog = $$v
      },
      expression: "show_block_user_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Block a User")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to block <" + _vm._s(_vm.otherName) + ">?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.blockUser()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBlockUserConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_conversation_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_conversation_delete_confirm_dialog = $$v
      },
      expression: "show_conversation_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Conversation")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, all messages under the conversation will be deleted.\n        Click OK to delete a conversation with <" + _vm._s(_vm.otherName) + ">, or\n        click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteEntireMessage()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeConversationDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "repost-request-dialog"
    },
    model: {
      value: (_vm.repostRequestActive),
      callback: function($$v) {
        _vm.repostRequestActive = $$v
      },
      expression: "repostRequestActive"
    }
  }, [_c('div', {
    staticClass: "_top dflex aling-center"
  }, [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": require('@/assets/repost_dollar.svg'),
      "width": "30",
      "alt": "repost dollar icon"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Repost Requests")])]), _vm._v(" "), _c('hr', {
    staticClass: "light my-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v("\n        Creators can send requests you to share their content.\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "ml-4"
  }, [_c('li', [_vm._v("Set your repost price in your messages")]), _vm._v(" "), _c('li', [_vm._v("\n          Creators can send you direct messages with their content attached to\n          preview\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          You have 3 days to accept the request or it’s automatically refunded\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          If you accept a request the content is reposted to your followers on\n          the home tab\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Repost requests remain on feeds for 7 days then is automatically\n          removed.\n        ")])]), _vm._v(" "), _c('hr', {
    staticClass: "light my-3"
  }), _vm._v(" "), _c('h2', {
    staticClass: "mb-3"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('div', {
    staticClass: "faqs"
  }, [_c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How & when do I get paid?")]), _vm._v(" "), _c('div', [_vm._v("\n            You must have a valid Stripe account connected, and accepted\n            requests payout in 2 days.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("What does ‘Enable SMS text’ mean?")]), _vm._v(" "), _c('div', [_vm._v("\n            SMS enabled means that any repost request you accept will send\n            links to the content to everyone on your SMS list and to your\n            followers on YouSound. The requester will pay for the SMS charges.\n            If you enable SMS you can charge more as SMS texts are more\n            valuable than sharing to the home feed alone.\n          ")])])])])]), _vm._v(" "), (_vm.smsActive) ? _c('SMS', {
    on: {
      "closeSMS": _vm.closeSMS
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1500a68c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/messages/index.vue
// module id = 1620
// module chunks = 180